jQuery(document).ready(function ($) {
    const base = 'gc-dashboard-sidebar';

    $(`.${base}__edit`).click(function(e) {
		const parent = $(this).parent();

		restoreInitialState();

		parent.find(`.${base}__detail-value`).hide();
		parent.find(`.${base}__detail-input`).show();
		parent.find(`.${base}__active`).show();
		parent.find(`.${base}__edit`).hide();
    });

	$(`.${base}__cancel`).click(function(e) {
		restoreInitialState();
	});

	$(`.${base}__save`).click(function(e) {
		const parent = $(this).parent().parent();

		const detail = parent.data('field');
		const value = parent.find(`.${base}__detail-input`).val();

		saveDetail(detail,value);
	});

	$(`.${base}__logout`).click(function() {
		document.cookie = 'authorization=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
		window.location.href = "/";
    });

	function restoreInitialState() {
		$(`.${base}__detail-input`).hide();
		$(`.${base}__detail-value`).show();
		$(`.${base}__edit`).show();
		$(`.${base}__active`).hide();
	}

	function saveDetail(detail,value) {
		const url = $(`.${base}__details`).data('url');
		const customerId = $(`.${base}__details`).data('id');

		$.ajax({
			url : url,
			type: 'POST',
			data : {
				id : customerId,
				detail: detail,
				value: value,
				action: 'saveDetail'
			}
		}).done(function(responseRaw) {
			let response = JSON.parse(responseRaw);
			
			if(response.success) {
				if(detail != 'password') {
					$(`.${base}__detail[data-field=${detail}] .${base}__detail-value`).html(value);
				}
				restoreInitialState();
			} else {
				showToast(response.message);
			}
		});
	} 
	
});

